const API_URL = import.meta.env.VITE_API_URL;

// Radares da Argentina (hidricosargentina), já sincronizados no índice UTC do Redemet pelo backend
export const getRadarARInformation = async () => {
  try {
    const response = await fetch(`${API_URL}/get-images-hidricos-ar`);
    if (response.ok) {
      const data = await response.json();
      localStorage.setItem("hidricos-ar-images", JSON.stringify(data.data));
    } else {
      console.error("ERRO NA REQUISIÇÃO (radares AR)");
    }
  } catch (error) {
    console.error("Erro ao obter os dados dos radares AR:", error);
  }
};
